const STAGING_PROJECT_ID = 'qxexuetvpcabdhcmihft';
const STAGING_SUPABASE_URL = `https://${STAGING_PROJECT_ID}.supabase.co`;
const STAGING_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF4ZXh1ZXR2cGNhYmRoY21paGZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5NDcxNTksImV4cCI6MjA5MjUyMzE1OX0.Tzghnyn_wXSnbUtx9vrSEPQBw50Krpi1PjqvQEo81lA';
const PROD_PROJECT_ID = 'wtqtlmhftamchbumdypi';
const PRODUCTION_HOSTS = new Set(['acerentdubai.ae', 'www.acerentdubai.ae']);

const envUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const envAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!envUrl || !envAnonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Set them in .env.local.'
  );
}

const envProjectId = extractProjectId(envUrl);

function extractProjectId(url: string) {
  const match = url.match(/^https?:\/\/([^.]+)\.supabase\.co/);
  if (!match) {
    throw new Error(`VITE_SUPABASE_URL is not a valid Supabase URL: ${url}`);
  }

  return match[1];
}

function shouldForceStagingProject() {
  if (envProjectId !== PROD_PROJECT_ID || typeof window === 'undefined') {
    return false;
  }

  const host = window.location.hostname.trim().toLowerCase();
  return !!host && !PRODUCTION_HOSTS.has(host);
}

function resolveSupabasePublicConfig() {
  if (!shouldForceStagingProject()) {
    return {
      url: envUrl,
      anonKey: envAnonKey,
      projectId: envProjectId,
    };
  }

  console.warn(
    `Non-production host ${window.location.hostname} was built with prod Supabase project ${PROD_PROJECT_ID}; using staging project ${STAGING_PROJECT_ID} instead.`
  );

  return {
    url: STAGING_SUPABASE_URL,
    anonKey: STAGING_SUPABASE_ANON_KEY,
    projectId: STAGING_PROJECT_ID,
  };
}

export const supabasePublicConfig = resolveSupabasePublicConfig();
export const supabaseUrl = supabasePublicConfig.url;
export const publicAnonKey = supabasePublicConfig.anonKey;
export const projectId = supabasePublicConfig.projectId;